export default {
	featureStatus: state => feature => {
		if (!_.isEmpty(state.featureFlags) && typeof feature === 'string') {
			const flag = state.featureFlags.find(featureFlag => featureFlag.tag === feature)

			return !_.isEmpty(flag) ? flag.active : false
		}

		return false
	},
	feature: state => feature => state.featureFlags.find(featureFlag => featureFlag.tag === feature)
}
